import React from "react";

const SubcategoryRow = ({ subcategory, provided, onEdit, onDelete, onCheckboxClick, isClubPremium }) => (
  <tr
    className="subcategory-row hoverable-row"
    ref={provided.innerRef}
    {...provided.draggableProps}
    {...provided.dragHandleProps}
  >
    <td>
      <div
        className={`icheckbox_square-orange icheck-item ${subcategory.checked ? 'checked' : ''} ${subcategory.default ? 'disabled' : ''}`}
        onClick={onCheckboxClick}
      >
        <input
          id={`checkbox${subcategory.id}`}
          className="i-checks icheck-input"
          type="checkbox"
          checked={subcategory.checked}
          readOnly
        />
      </div>
    </td>
    <td className="add-margin-right-10">
      <i className="fa fa-bars drag_handle ui-sortable-handle"></i>
    </td>
    <td>
      {subcategory.name}
      {subcategory.name === 'Switch Accounts' &&
        <i className="gga-info-circle" title={window.I18n.t('mobile_app_dashboard.home.switch_accounts')}></i>
      }
    </td>
    <td>
      {!subcategory.system_field && isClubPremium && (
        <div className="actions">
          <a onClick={(e) => { e.stopPropagation(); onEdit(); }} className="edit-action add-margin-right-10">
            <span className="fa fa-pencil-square-o" />
            {window.I18n.t('mobile_app_dashboard.menu.edit')}
          </a>
          {!subcategory.default && (
            <>
              <span>• </span>
              <a onClick={(e) => { e.stopPropagation(); onDelete(); }} className="remove-action">
                <span className="fa fa-trash-o" />
                {window.I18n.t('mobile_app_dashboard.menu.remove')}
              </a>
            </>
          )}
        </div>
      )}
    </td>
  </tr>
);

export default SubcategoryRow;
